import ticketTags from './crm/tags'

export default ticketTags
